import React from 'react';
import General from './tabs/General';
import { EditFormContainer } from 'components/common/Containers';
import { useParams } from 'react-router-dom';
import { useHasPermissions } from 'hooks/useHasPermissions';
import { PERMISSIONS } from '../../../constants';

export default function EndpointEditPage() {
  const { id } = useParams();
  const canEditPublisher = useHasPermissions(PERMISSIONS.PUBLISHERS_MANAGEMENT);
  return (
    <EditFormContainer>
      <General id={id} editable={canEditPublisher} />
    </EditFormContainer>
  );
}
